<template>
  <div class="container homepage flex">
    <div class="bg-img">
      <div class="cloud">
        <img src="../assets/images/cloud.png" alt="bg-img" />
      </div>
      <div class="curveline">
        <img src="../assets/images/curveline.png" alt="bg-img" />
      </div>
      <div class="butterfly">
        <img src="../assets/images/butterfly.png" alt="bg-img" />
      </div>
      <div class="scale">
        <img src="../assets/images/scale.png" alt="bg-img" />
      </div>
      <div class="rainbow">
        <img src="../assets/images/rainbow.png" alt="bg-img" />
      </div>
    </div>
    <div class="form-container flex">
      <div class="logo">
        <img src="../assets/images/UP_SKOOL_LOGO.png" alt="" />
      </div>
      <div class="text-container">
        <h1>Welcome to Up-skool!</h1>
        <p v-if="!isLoading">Setting up your learning journey...</p>
        <p v-else>{{ loadingMessage }}</p>
      </div>
      
      <!-- Loading Animation -->
      <div class="loading-container">
        <div class="loading-spinner">
          <div class="spinner-ring"></div>
          <div class="spinner-ring"></div>
          <div class="spinner-ring"></div>
        </div>
        <div class="loading-text">
          {{ loadingMessage }}
        </div>
      </div>

      <!-- Fun Facts -->
      <div class="fun-facts">
        <div class="fact" v-if="currentFactIndex === 0">
          <span class="fact-icon">🎯</span>
          <span class="fact-text">Over 10,000 interactive questions to explore!</span>
        </div>
        <div class="fact" v-if="currentFactIndex === 1">
          <span class="fact-icon">🏆</span>
          <span class="fact-text">Personalized learning paths for every child</span>
        </div>
        <div class="fact" v-if="currentFactIndex === 2">
          <span class="fact-icon">📊</span>
          <span class="fact-text">Track progress with detailed analytics</span>
        </div>
      </div>

      <!-- Error Message -->
      <div v-if="errorMessage" class="error-container">
        <p class="error-text">{{ errorMessage }}</p>
        <button @click="retryGuestLogin" class="retry-button">
          Try Again
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "GuestSignup",
  data() {
    return {
      isLoading: true,
      currentFactIndex: 0,
      errorMessage: "",
      loadingMessage: "Setting up your learning journey...",
    };
  },
  computed: {
    ...mapGetters(["isLoggedIn"]),
  },
  methods: {
    ...mapActions(["guestLogin"]),
    
    async performGuestLogin() {
      try {
        this.isLoading = true;
        this.errorMessage = "";
        this.loadingMessage = "Creating your account...";

        // Call the guest login API
        await this.guestLogin();

        // Success - redirect to home
        this.loadingMessage = "Welcome! Redirecting now...";
        setTimeout(() => {
          this.$router.push({ name: "home" });
        }, 1000);

      } catch (error) {
        console.error("Guest login error:", error);
        this.isLoading = false;
        this.errorMessage = 
          error.response?.data?.msg || 
          "Something went wrong. Please try again.";
      }
    },

    retryGuestLogin() {
      this.performGuestLogin();
    },

    startFactRotation() {
      setInterval(() => {
        this.currentFactIndex = (this.currentFactIndex + 1) % 3;
      }, 3000);
    },

  },

  mounted() {
    // Redirect if already logged in
    if (this.isLoggedIn) {
      this.$router.push({ name: "home" });
      return;
    }

    // Start the guest login process immediately
    this.performGuestLogin();
    
    // Start rotating fun facts
    this.startFactRotation();
  },
};
</script>

<style scoped>
.homepage {
  min-height: 100vh;
  width: 100%;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
}

.bg-img {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  overflow: hidden;
}

.bg-img div {
  position: absolute;
  width: auto;
}

.cloud {
  top: 5%;
  right: 10%;
  width: 15%;
}

.curveline {
  top: 20%;
  left: 5%;
  width: 12%;
}

.butterfly {
  top: 10%;
  left: 20%;
  width: 8%;
}

.scale {
  bottom: 20%;
  right: 15%;
  width: 10%;
}

.rainbow {
  bottom: 10%;
  left: 10%;
  width: 20%;
}

.form-container {
  padding: 2rem;
  gap: 1.5rem;
  width: 100%;
  max-width: 600px;
  position: relative;
  margin: auto;
  top: 5%;
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.logo img {
  width: 120px;
  height: auto;
  margin-bottom: 1rem;
}

.text-container h1 {
  font-size: 2.5rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 0.5rem;
  background: linear-gradient(45deg, #8919e7, #ff6b6b);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.text-container p {
  color: #666;
  font-size: 1.1rem;
  margin-bottom: 2rem;
}

/* Loading Animation */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  margin: 2rem 0;
}

.loading-spinner {
  position: relative;
  width: 80px;
  height: 80px;
}

.spinner-ring {
  position: absolute;
  border: 4px solid transparent;
  border-top: 4px solid #8919e7;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.spinner-ring:nth-child(1) {
  width: 80px;
  height: 80px;
  animation-delay: 0s;
}

.spinner-ring:nth-child(2) {
  width: 60px;
  height: 60px;
  top: 10px;
  left: 10px;
  border-top-color: #ff6b6b;
  animation-delay: 0.3s;
}

.spinner-ring:nth-child(3) {
  width: 40px;
  height: 40px;
  top: 20px;
  left: 20px;
  border-top-color: #00d4aa;
  animation-delay: 0.6s;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Loading Text */
.loading-text {
  font-size: 1.3rem;
  font-weight: 600;
  color: #333;
  text-align: center;
  margin-top: 1rem;
  background: linear-gradient(45deg, #8919e7, #ff6b6b);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: pulse 2s infinite;
}

/* Fun Facts */
.fun-facts {
  margin: 2rem 0;
  min-height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.fact {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  padding: 1rem;
  background: linear-gradient(45deg, #e8eaf6, #f3e5f5);
  border-radius: 15px;
  border-left: 4px solid #8919e7;
  animation: fadeInUp 0.5s ease;
}

.fact-icon {
  font-size: 1.5rem;
}

.fact-text {
  font-weight: 600;
  color: #555;
  font-size: 0.95rem;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Error Handling */
.error-container {
  text-align: center;
  margin-top: 2rem;
}

.error-text {
  color: #dc3545;
  font-weight: 600;
  margin-bottom: 1rem;
}

.retry-button {
  background: #8919e7;
  color: white;
  border: none;
  padding: 0.8rem 2rem;
  border-radius: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.retry-button:hover {
  background: #6b14b3;
  transform: translateY(-2px);
}

/* Responsive Design */
@media screen and (max-width: 768px) {
  .form-container {
    padding: 1.5rem;
    max-width: 90%;
    top: 2%;
  }
  
  .text-container h1 {
    font-size: 2rem;
  }
  
  .logo img {
    width: 100px;
  }
  
  .bg-img div {
    display: none;
  }
}

@media screen and (max-width: 480px) {
  .form-container {
    padding: 1rem;
    max-width: 95%;
  }
  
  .text-container h1 {
    font-size: 1.8rem;
  }
  
  .loading-spinner {
    width: 60px;
    height: 60px;
  }
  
  .spinner-ring:nth-child(1) {
    width: 60px;
    height: 60px;
  }
  
  .spinner-ring:nth-child(2) {
    width: 45px;
    height: 45px;
    top: 7.5px;
    left: 7.5px;
  }
  
  .spinner-ring:nth-child(3) {
    width: 30px;
    height: 30px;
    top: 15px;
    left: 15px;
  }
}
</style>